import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    nombreComercial: '',
    razonSocial: '',
    condicionFiscalId: 0,
    condicionFiscal: {},
    condicionFiscalNombre: null,
    documentoTipoId: 0,
    documentoTipo: null,
    documentoTipoNombre: null,
    documentoNumero: '',
    giroEmpresaId: 0,
    giroEmpresa: null,
    giroEmpresaNombre: null,
    direccion: '',
    paisId: 0,
    pais: {},
    paisNombre: null,
    provinciaId: 0,
    provincia: {},
    provinciaNombre: null,
    localidadId: 0,
    localidad: {},
    localidadNombre: null,
    codigoPostal: '',
    telefono: '',
    celular: '',
    whatsapp: '',
    email: '',
    email2: '',
    feeAgencia: 0,
    aplicarEscalaFee: false,
    feeAgenciaPremios: 0,
    discriminarFeePremios: false,
    discriminarFeePresupuesto: false,
    ocultarLeyendaFeePresupuesto: false,
    // feeComisionable: false,
    pjeFinanciacion: 0,
    aplicarEscalaFinanciacion: false,
    discriminarPjeFinanciacion: false,
    feeSobreFinanciacion: false,
    discriminarCategoriaServicio: false,
    servicioPropioNoAplicaFee: false,
    prontoPagoFeeDiferenciado: false,
    pjeRecargoServicioPropio: 0,
    pjeMargenMinimoCotizacion: 0,
    pjeMargenMinimoCotizacionPropio: 0,
    pjeMargenMinimoCotizacionTerceros: 0,
    parametrosCostoInterno: false,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    plazoPago: 0,
    numeroProveedor: '',
    grandesContribuyentes: false,
    sistemaCirculacionAbierta: false,
    seleccionProvinciasPresupuestos: false,
    observaciones: '',
    inactivo: false,
    rowVersion: null,

    escalasFee: [],
    escalasFinanciacion: [],
    
    /* Parametros segun pais */
    giroEmpresaVisible: false,

    clienteDatos: [],
    clienteObservaciones: '',
    clienteAccionesDatos: [],
    clienteContactosDatos: [],
    clienteContactosAdministracionDatos: [],
    clienteRubrosTrabajosDatos: [],
    clienteEscalasFeeDatos: [],
    clienteEscalasFinanciacionDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_CLIENTE' (state, params) {
        state.id = params.clienteId;
        state.nombreComercial = '';
        state.razonSocial = '';
        state.condicionFiscalId = 0;
        state.condicionFiscal= null;
        state.condicionFiscalNombre = null;
        state.documentoTipoId = 0;
        state.documentoTipo = null;
        state.documentoTipoNombre = null;
        state.documentoNumero = '';
        state.giroEmpresaId = 0;
        state.giroEmpresa = null;
        state.giroEmpresaNombre = null;
        state.direccion = '';
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
        state.codigoPostal = '';
        state.telefono = '';
        state.celular = '';
        state.whatsapp = '';
        state.email = '';
        state.email2 = '';
        state.feeAgencia = 0;
        state.aplicarEscalaFee = false;
        state.feeAgenciaPremios = 0;
        state.discriminarFeePremios = false;
        state.discriminarFeePresupuesto = false;
        state.ocultarLeyendaFeePresupuesto = false;
        // state.feeComisionable = false;
        state.pjeFinanciacion = 0;
        state.aplicarEscalaFinanciacion = false;
        state.discriminarPjeFinanciacion = false;
        state.feeSobreFinanciacion = false;
        state.discriminarCategoriaServicio = false;
        state.servicioPropioNoAplicaFee = false;
        state.prontoPagoFeeDiferenciado = false;
        state.pjeRecargoServicioPropio = 0;
        state.pjeMargenMinimoCotizacion = 0;
        state.pjeMargenMinimoCotizacionPropio = 0;
        state.pjeMargenMinimoCotizacionTerceros = 0;
        state.parametrosCostoInterno = false;
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.formaPagoId = 0;
        state.formaPago = null;
        state.formaPagoNombre = null;
        state.plazoPago = 0;
        state.numeroProveedor = '';
        state.grandesContribuyentes = false;
        state.sistemaCirculacionAbierta = false;
        state.seleccionProvinciasPresupuestos = false;
        state.observaciones= '';
        state.inactivo = false;
        state.rowVersion = null;

        state.escalasFee = [];
        state.escalasFinanciacion = [];

        state.giroEmpresaVisible = false;

        /* Empresa */
        switch (params.paisId) {
            case 5: /* Chile */
                state.giroEmpresaVisible = true;
                break;
        }
    },
    'SET_CLIENTE' (state, cliente) {
        state.nombreComercial = cliente.nombreComercial.toUpperCase().trim();
        state.razonSocial = cliente.razonSocial.toUpperCase().trim();
        state.condicionFiscalId= (cliente.condicionFiscal) ? parseInt(cliente.condicionFiscal.id) : 0;
        state.condicionFiscal= cliente.condicionFiscal;
        state.condicionFiscalNombre = cliente.condicionFiscal ? cliente.condicionFiscal.nombre.trim() : null;
        state.documentoTipoId = cliente.documentoTipo? cliente.documentoTipo.id : 0;
        state.documentoTipo = cliente.documentoTipo;
        state.documentoTipoNombre = cliente.documentoTipo? cliente.documentoTipo.nombre.trim() : null;
        state.documentoNumero = cliente.documentoNumero.trim();
        state.giroEmpresaId = cliente.giroEmpresa? cliente.giroEmpresa.id : 0;
        state.giroEmpresa = cliente.giroEmpresa;
        state.giroEmpresaNombre = cliente.giroEmpresa? cliente.giroEmpresa.nombre.trim() : null;
        state.direccion = cliente.direccion.toUpperCase().trim();
        state.paisId= (cliente.pais) ? parseInt(cliente.pais.id) : 0;
        state.pais = cliente.pais;
        state.paisNombre = cliente.pais ? cliente.pais.nombre.trim() : null;
        state.provinciaId= (cliente.provincia) ? parseInt(cliente.provincia.id) : 0;
        state.provincia = cliente.provincia;
        state.provinciaNombre = cliente.provincia ? cliente.provincia.nombre.trim() : null;
        state.localidadId= (cliente.localidad) ? parseInt(cliente.localidad.id) : 0;
        state.localidad = cliente.localidad;
        state.localidadNombre = cliente.localidad ? cliente.localidad.nombre.trim() : null;
        state.codigoPostal = cliente.codigoPostal.trim();
        state.telefono = cliente.telefono;
        state.celular = cliente.celular;
        state.whatsapp = cliente.whatsapp;
        state.email = cliente.email;
        state.email2 = cliente.email2;
        state.feeAgencia = parseFloat(cliente.feeAgencia);
        state.aplicarEscalaFee = (/true/i).test(cliente.aplicarEscalaFee);
        state.feeAgenciaPremios = parseFloat(cliente.feeAgenciaPremios);
        state.discriminarFeePremios = (/true/i).test(cliente.discriminarFeePremios);
        state.discriminarFeePresupuesto = (/true/i).test(cliente.discriminarFeePresupuesto);
        state.ocultarLeyendaFeePresupuesto = (/true/i).test(cliente.ocultarLeyendaFeePresupuesto);
        // state.feeComisionable = (/true/i).test(cliente.feeComisionable);
        state.pjeFinanciacion = parseFloat(cliente.pjeFinanciacion);
        state.aplicarEscalaFinanciacion = (/true/i).test(cliente.aplicarEscalaFinanciacion);
        state.discriminarPjeFinanciacion = (/true/i).test(cliente.discriminarPjeFinanciacion);
        state.feeSobreFinanciacion = (/true/i).test(cliente.feeSobreFinanciacion);
        state.discriminarCategoriaServicio = (/true/i).test(cliente.discriminarCategoriaServicio);
        state.servicioPropioNoAplicaFee = (/true/i).test(cliente.servicioPropioNoAplicaFee);
        state.prontoPagoFeeDiferenciado = (/true/i).test(cliente.prontoPagoFeeDiferenciado);
        state.pjeRecargoServicioPropio = parseFloat(cliente.pjeRecargoServicioPropio);
        state.pjeMargenMinimoCotizacion = parseFloat(cliente.pjeMargenMinimoCotizacion);
        state.pjeMargenMinimoCotizacionPropio = parseFloat(cliente.pjeMargenMinimoCotizacionPropio);
        state.pjeMargenMinimoCotizacionTerceros = parseFloat(cliente.pjeMargenMinimoCotizacionTerceros);
        state.parametrosCostoInterno = (/true/i).test(cliente.parametrosCostoInterno);
        state.pjeGastosFijos = parseFloat(cliente.pjeGastosFijos);
        state.pjeInversionFutura = parseFloat(cliente.pjeInversionFutura);
        state.pjeImpuestosInternos = parseFloat(cliente.pjeImpuestosInternos);
        state.formaPagoId = (cliente.formaPago) ? parseInt(cliente.formaPago.id) : 0;
        state.formaPago = cliente.formaPago;
        state.formaPagoNombre = cliente.formaPago ? cliente.formaPago.nombre.trim() : null;
        state.plazoPago = parseInt(cliente.plazoPago);
        state.numeroProveedor = cliente.numeroProveedor.toUpperCase().trim();
        state.grandesContribuyentes = (/true/i).test(cliente.grandesContribuyentes);
        state.sistemaCirculacionAbierta = (/true/i).test(cliente.sistemaCirculacionAbierta);
        state.seleccionProvinciasPresupuestos = (/true/i).test(cliente.seleccionProvinciasPresupuestos);
        state.observaciones = cliente.observaciones.trim();
        state.inactivo = (/true/i).test(cliente.inactivo);
        state.rowVersion = cliente.rowVersion;

        state.escalasFee = cliente.escalasFee.map(escala => ({
            id: helpers.methods.getUUID(),
            escalaId: escala.id,
            montoMinimo: parseFloat(escala.montoMinimo),
            montoMaximo: parseFloat(escala.montoMaximo),
            pjeFeeAgencia: parseFloat(escala.pjeFeeAgencia)
        }))

        state.escalasFinanciacion = cliente.escalasFinanciacion.map(escala => ({
            id: helpers.methods.getUUID(),
            escalaId: escala.id,
            montoMinimo: parseFloat(escala.montoMinimo),
            montoMaximo: parseFloat(escala.montoMaximo),
            pjeFinanciacion: parseFloat(escala.pjeFinanciacion)
        }))
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        if (pais) {
            state.paisId = pais.id? parseInt(pais.id) : 0;
            state.paisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.paisId = 0;
            state.paisNombre = null;
        }
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        if (provincia) {
            state.provinciaId = provincia.id? parseInt(provincia.id) : 0;
            state.provinciaNombre = provincia.nombre? provincia.nombre.trim() : null;
        } else {
            state.provinciaId = 0;
            state.provinciaNombre = null;
        }
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.localidad = localidad;
        if (localidad) {
            state.localidadId = localidad.id? parseInt(localidad.id) : 0;
            state.localidadNombre = localidad.nombre? localidad.nombre.trim() : null;
        } else {
            state.localidadId = 0;
            state.localidadNombre = null;
        }
    },
    'SET_CONDICION_FISCAL'(state, condicionFiscal) {
        state.condicionFiscal= condicionFiscal;
        if (condicionFiscal) {
            state.condicionFiscalId = condicionFiscal.id? parseInt(condicionFiscal.id) : 0;
            state.condicionFiscalNombre = condicionFiscal.nombre? condicionFiscal.nombre.trim() : null;
        } else {
            state.condicionFiscalId = 0;
            state.condicionFiscalNombre = null;
        }
    },
    'SET_DOCUMENTO_TIPO'(state, documentoTipo) {
        state.documentoTipo= documentoTipo;
        if (documentoTipo) {
            state.documentoTipoId = documentoTipo.id? documentoTipo.id : 0;
            state.documentoTipoNombre = documentoTipo.nombre? documentoTipo.nombre.trim() : null;
        } else {
            state.documentoTipoId = 0;
            state.documentoTipoNombre = null;
        }
    },
    'SET_GIRO_EMPRESA'(state, giroEmpresa) {
        state.giroEmpresa = giroEmpresa;
        if (giroEmpresa) {
            state.giroEmpresaId = giroEmpresa.id? giroEmpresa.id : 0;
            state.giroEmpresaNombre = giroEmpresa.nombre? giroEmpresa.nombre.trim() : null;
        } else {
            state.giroEmpresaId = 0;
            state.giroEmpresaNombre = null;
        }
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPago= formaPago;
        if (formaPago) {
            state.formaPagoId = formaPago.id? parseInt(formaPago.id) : 0;
            state.formaPagoNombre = formaPago.nombre? formaPago.nombre.trim() : null;
        } else {
            state.formaPagoId = 0;
            state.formaPagoNombre = null;
        }
    },
    'ADD_ESCALA_FEE'(state, escalaFee) {
        state.escalasFee.push({
            id: helpers.methods.getUUID(),
            escalaId: 0,
            montoMinimo: parseFloat(escalaFee.montoMinimo),
            montoMaximo: parseFloat(escalaFee.montoMaximo),
            pjeFeeAgencia: parseFloat(escalaFee.pjeFeeAgencia)
        })

        state.escalasFee.sort((a, b) => {
            if (a.montoMaximo == 0) {
                return 1;
            } else if (b.montoMaximo == 0) {
                return -1;
            } 
            return parseFloat(a.montoMaximo) - parseFloat(b.montoMaximo)
        });

        let montoMinimo = 0;
        state.escalasFee.forEach(escala => {
            escala.montoMinimo = montoMinimo;
            montoMinimo = escala.montoMaximo + 1;
        });
    },
    'REMOVE_ESCALA_FEE'(state, escalaFeeId) {
        let itemKey = state.escalasFee
            .findIndex(escala => escala.id == escalaFeeId);

        if (itemKey != -1) {
            state.escalasFee.splice(itemKey, 1);
        }

        state.escalasFee.sort((a, b) => {
            if (a.montoMaximo == 0) {
                return 1;
            } else if (b.montoMaximo == 0) {
                return -1;
            } 
            return parseFloat(a.montoMaximo) - parseFloat(b.montoMaximo)
        });

        let montoMinimo = 0;
        state.escalasFee.forEach(escala => {
            escala.montoMinimo = montoMinimo;
            montoMinimo = escala.montoMaximo + 1;
        });
    },
    'ADD_ESCALA_FINANCIACION'(state, escalaFinanciacion) {
        state.escalasFinanciacion.push({
            id: helpers.methods.getUUID(),
            escalaId: 0,
            montoMinimo: parseFloat(escalaFinanciacion.montoMinimo),
            montoMaximo: parseFloat(escalaFinanciacion.montoMaximo),
            pjeFinanciacion: parseFloat(escalaFinanciacion.pjeFinanciacion)
        })

        state.escalasFinanciacion.sort((a, b) => {
            if (a.montoMaximo == 0) {
                return 1;
            } else if (b.montoMaximo == 0) {
                return -1;
            } 
            return parseFloat(a.montoMaximo) - parseFloat(b.montoMaximo)
        });

        let montoMinimo = 0;
        state.escalasFinanciacion.forEach(escala => {
            escala.montoMinimo = montoMinimo;
            montoMinimo = escala.montoMaximo + 1;
        });
    },
    'REMOVE_ESCALA_FINANCIACION'(state, escalaFinanciacionId) {
        let itemKey = state.escalasFinanciacion
            .findIndex(escala => escala.id == escalaFinanciacionId);

        if (itemKey != -1) {
            state.escalasFinanciacion.splice(itemKey, 1);
        }

        state.escalasFinanciacion.sort((a, b) => {
            if (a.montoMaximo == 0) {
                return 1;
            } else if (b.montoMaximo == 0) {
                return -1;
            } 
            return parseFloat(a.montoMaximo) - parseFloat(b.montoMaximo)
        });

        let montoMinimo = 0;
        state.escalasFinanciacion.forEach(escala => {
            escala.montoMinimo = montoMinimo;
            montoMinimo = escala.montoMaximo + 1;
        });
    },

    'INICIALIZAR_DATOS'(state) {
        state.clienteDatos = [];
        state.clienteObservaciones = '';
        state.clienteAccionesDatos = [];
        state.clienteContactosDatos = [];
        state.clienteContactosAdministracionDatos = [];
        state.clienteRubrosTrabajosDatos = [];
        state.clienteEscalasFeeDatos = [];
        state.clienteEscalasFinanciacionDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.clienteDatos = params.clienteDatos;
        state.clienteObservaciones = params.clienteObservaciones;
        state.clienteAccionesDatos = params.clienteAccionesDatos;
        state.clienteContactosDatos = params.clienteContactosDatos;
        state.clienteContactosAdministracionDatos = params.clienteContactosAdministracionDatos;
        state.clienteRubrosTrabajosDatos = params.clienteRubrosTrabajosDatos;
        state.clienteEscalasFeeDatos = params.clienteEscalasFeeDatos;
        state.clienteEscalasFinanciacionDatos = params.clienteEscalasFinanciacionDatos;
    },
};

const getters = {
    getField,

    feeAgencia (state) {
        return state.feeAgencia;
    },
    feeAgenciaPremios (state) {
        return state.feeAgenciaPremios;
    },
    discriminarFeePremios (state) {
        return state.discriminarFeePremios;
    },
    discriminarFeePresupuesto (state) {
        return state.discriminarFeePresupuesto;
    },
    ocultarLeyendaFeePresupuesto (state) {
        return state.ocultarLeyendaFeePresupuesto;
    },
};

const actions = {
    inicializar ( { rootState, commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            let params = {
                clienteId,
                paisId
            }

            commit('INICIALIZAR_CLIENTE', params);

            let getCliente = false;
            if (clienteId) {
                if (clienteId != 0) {
                    getCliente = true;
                }
            }
            if (getCliente) {
                apiAxios.get(`clientes/${clienteId}/abm` ) 
                    .then(res => {
                        commit('SET_CLIENTE', res.data);
                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            //(/true/i).test(cuentaCorriente.selected)

            let servicioPropioNoAplicaFee = (/true/i).test(state.servicioPropioNoAplicaFee);
            let pjeRecargoServicioPropio = parseFloat(state.pjeRecargoServicioPropio);

            let pjeMargenMinimoCotizacion = parseFloat(state.pjeMargenMinimoCotizacion);
            let pjeMargenMinimoCotizacionPropio = parseFloat(state.pjeMargenMinimoCotizacionPropio);
            let pjeMargenMinimoCotizacionTerceros = parseFloat(state.pjeMargenMinimoCotizacionTerceros);
    
            if (!(/true/i).test(state.discriminarCategoriaServicio)) {
                pjeRecargoServicioPropio = 0;
                servicioPropioNoAplicaFee = false;
                /* Tenemos un único margen mínimo */
                pjeMargenMinimoCotizacionPropio = 0;
                pjeMargenMinimoCotizacionTerceros = 0;
            } else {
                /* Tenemos un margen por categoría de servicio */
                pjeMargenMinimoCotizacion = 0;
            }

            let parametrosCostoInterno = (/true/i).test(state.parametrosCostoInterno);
            let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
            let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
            let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);
            if (!parametrosCostoInterno) {
                pjeGastosFijos = 0;
                pjeInversionFutura = 0;
                pjeImpuestosInternos = 0;
            }

            let ocultarLeyendaFeePresupuesto = (/true/i).test(state.ocultarLeyendaFeePresupuesto);
            if ((/true/i).test(state.discriminarFeePresupuesto)) {
                ocultarLeyendaFeePresupuesto = false;
            }

            let escalasFee = state.escalasFee.map(escala => ({
                id: escala.escalaId,
                montoMinimo: parseFloat(escala.montoMinimo),
                montoMaximo: parseFloat(escala.montoMaximo),
                pjeFeeAgencia: parseFloat(escala.pjeFeeAgencia)                
            }));

            let escalasFinanciacion = state.escalasFinanciacion.map(escala => ({
                id: escala.escalaId,
                montoMinimo: parseFloat(escala.montoMinimo),
                montoMaximo: parseFloat(escala.montoMaximo),
                pjeFinanciacion: parseFloat(escala.pjeFinanciacion)                
            }));

            let cliente= {
                nombreComercial: state.nombreComercial.toUpperCase().trim(),
                razonSocial: state.razonSocial.toUpperCase().trim(), 
                condicionFiscalId: state.condicionFiscalId,
                documentoTipoId: state.documentoTipoId,
                documentoNumero: state.documentoNumero.toUpperCase().trim(),  
                giroEmpresaId: state.giroEmpresaId,
                direccion: state.direccion.toUpperCase().trim(),
                paisId: state.paisId,
                provinciaId: state.provinciaId,
                localidadId: state.localidadId,
                codigoPostal: state.codigoPostal.toUpperCase().trim(),
                telefono: state.telefono.toUpperCase().trim(),
                celular: state.celular.toUpperCase().trim(),
                whatsapp: state.whatsapp.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                email2: state.email2.toLowerCase().trim(),
                feeAgencia: parseFloat(state.feeAgencia),
                aplicarEscalaFee: (/true/i).test(state.aplicarEscalaFee),
                feeAgenciaPremios: parseFloat(state.feeAgenciaPremios),
                discriminarFeePremios: (/true/i).test(state.discriminarFeePremios),
                discriminarFeePresupuesto: (/true/i).test(state.discriminarFeePresupuesto),
                ocultarLeyendaFeePresupuesto,
                // feeComisionable: (/true/i).test(state.feeComisionable),
                pjeFinanciacion: parseFloat(state.pjeFinanciacion),
                aplicarEscalaFinanciacion: (/true/i).test(state.aplicarEscalaFinanciacion),
                discriminarPjeFinanciacion: (/true/i).test(state.discriminarPjeFinanciacion),
                feeSobreFinanciacion: (/true/i).test(state.feeSobreFinanciacion),
                discriminarCategoriaServicio: (/true/i).test(state.discriminarCategoriaServicio),
                servicioPropioNoAplicaFee,
                prontoPagoFeeDiferenciado: (/true/i).test(state.prontoPagoFeeDiferenciado),
                pjeRecargoServicioPropio,
                pjeMargenMinimoCotizacion,
                pjeMargenMinimoCotizacionPropio,
                pjeMargenMinimoCotizacionTerceros,
                parametrosCostoInterno,
                pjeGastosFijos,
                pjeInversionFutura,
                pjeImpuestosInternos,
                formaPagoId: parseInt(state.formaPagoId),
                // formaPago: state.formaPago,
                plazoPago: parseInt(state.plazoPago),
                numeroProveedor: state.numeroProveedor.toUpperCase().trim(),
                grandesContribuyentes: (/true/i).test(state.grandesContribuyentes),
                sistemaCirculacionAbierta: (/true/i).test(state.sistemaCirculacionAbierta),
                seleccionProvinciasPresupuestos: (/true/i).test(state.seleccionProvinciasPresupuestos),
                observaciones: state.observaciones.trim(),
                inactivo: state.inactivo,
                escalasFee,
                escalasFinanciacion
            }

            let url = 'clientes';

            if (state.id != 0) {
                cliente.rowVersion = state.rowVersion;
                url += '/' + state.id;
            } 

            apiAxios.post(url, cliente)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },
    setProvincia: ({commit}, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },
    setLocalidad: ({commit}, localidad) => {
        commit('SET_LOCALIDAD', localidad);
    },
    setCondicionFiscal: ({commit}, condicionFiscal) => {
        commit('SET_CONDICION_FISCAL', condicionFiscal);
    },
    setDocumentoTipo: ({commit}, documentoTipo) => {
        commit('SET_DOCUMENTO_TIPO', documentoTipo);
    },
    setGiroEmpresa: ({commit}, giroEmpresa) => {
        commit('SET_GIRO_EMPRESA', giroEmpresa);
    },
    setFormaPago: ({commit}, formaPago) => {
        commit('SET_FORMA_PAGO', formaPago);
    },
    addEscalaFee: ({commit}, escalaFee) => {
        commit('ADD_ESCALA_FEE', escalaFee);
    },
    removeEscalaFee: ({commit}, escalaFee) => {
        commit('REMOVE_ESCALA_FEE', escalaFee);
    },
    addEscalaFinanciacion: ({commit}, escalaFinanciacion) => {
        commit('ADD_ESCALA_FINANCIACION', escalaFinanciacion);
    },
    removeEscalaFinanciacion: ({commit}, escalaFinanciacionId) => {
        commit('REMOVE_ESCALA_FINANCIACION', escalaFinanciacionId);
    },

    getDatos ( { rootState, commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            commit('INICIALIZAR_DATOS');
            
            let getCliente = false;

            if (clienteId) {
                if (clienteId != 0) {
                    getCliente = true;
                }
            }

            if (getCliente) {
                apiAxios.get(`clientes/${clienteId}`) 
                .then(res => {
                    let formatoDocumentoNumero = '';
                    switch (res.data.documentoTipoId) {
                        case 2:
                            formatoDocumentoNumero = 'cuit';
                            break;
                        case 4:
                            formatoDocumentoNumero = 'ein';
                            break;
                    }
                    let clienteDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombreComercial', 'campo': 'Nombre Comercial', 'valor': res.data.nombreComercial, 'formato': '' },
                        { 'nombre': 'razonSocial', 'campo': 'Razón Social', 'valor': res.data.razonSocial, 'formato': '' },
                        { 'nombre': 'condicionFiscal', 'campo': 'Condición Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                        { 'nombre': 'documentoTipo', 'campo': 'Tipo Identificación', 'valor': res.data.documentoTipo, 'formato': '' },
                        { 'nombre': 'documentoNumero', 'campo': 'Cod.Identificación', 'valor': res.data.documentoNumero, 'formato': formatoDocumentoNumero },
                    ];
                        
                    if (paisId == 5) {
                        clienteDatos.push ({ 'nombre': 'giroEmpresa', 'campo': 'Giro Empresa', 'valor': res.data.giroEmpresa, 'formato': '' })    
                    }

                    clienteDatos.push (
                        { 'nombre': 'direccion', 'campo': 'Dirección', 'valor': res.data.direccion, 'formato': '' },
                        { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                        { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                        { 'nombre': 'localidad', 'campo': 'Localidad', 'valor': res.data.localidad, 'formato': '' },
                        { 'nombre': 'codigoPostal', 'campo': 'Cod.Postal', 'valor': res.data.codigoPostal, 'formato': '' },
                        { 'nombre': 'telefono', 'campo': 'Teléfono', 'valor': res.data.telefono, 'formato': '' },
                        { 'nombre': 'celular', 'campo': 'Celular', 'valor': res.data.celular, 'formato': '' },
                        { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        { 'nombre': 'email2', 'campo': 'Email', 'valor': res.data.email2, 'formato': '' },
                        { 'nombre': 'feeAgencia', 'campo': 'Fee Agencia', 'valor': res.data.feeAgencia, 'formato': 'porcentaje' },
                        { 'nombre': 'aplicarEscalaFee', 'campo': 'Aplica Escala Fee', 'valor': res.data.aplicarEscalaFee ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'discriminarFeePresupuesto', 'campo': 'Discriminar Fee Agencia en Presupuestos', 'valor': (res.data.discriminarFeePresupuesto) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'ocultarLeyendaFeePresupuesto', 'campo': 'Ocultar Leyenda Fee Agencia en Presupuestos', 'valor': (res.data.ocultarLeyendaFeePresupuesto) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'feeAgenciaPremios', 'campo': 'Fee de Rubros Diferenciados', 'valor': res.data.feeAgenciaPremios, 'formato': 'porcentaje' },
                        { 'nombre': 'discriminarFeePremios', 'campo': 'Discriminar Fee de Rubros Diferenciados', 'valor': (res.data.discriminarFeePremios) ? 'Si' : 'No', 'formato': '' },
                        // { 'nombre': 'feeComisionable', 'campo': 'Fee Comisionable', 'valor': res.data.feeComisionable? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'pjeFinanciacion', 'campo': 'Pje Financiacion', 'valor': res.data.pjeFinanciacion, 'formato': 'porcentaje' },
                        { 'nombre': 'aplicarEscalaFinanciacion', 'campo': 'Aplica Escala Financiacion', 'valor': res.data.aplicarEscalaFinanciacion ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'discriminarPjeFinanciacion', 'campo': 'Discriminar Pje de Financiacion', 'valor': (res.data.discriminarPjeFinanciacion) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'feeSobreFinanciacion', 'campo': 'Fee sobre Pje de Financiacion', 'valor': (res.data.feeSobreFinanciacion) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'prontoPagoFeeDiferenciado', 'campo': 'Pronto Pago en Fee Diferenciado', 'valor': (res.data.prontoPagoFeeDiferenciado) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'discriminarCategoriaServicio', 'campo': 'Discriminar Categoría de Servicio', 'valor': (res.data.discriminarCategoriaServicio) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'pjeRecargoServicioPropio', 'campo': 'Pje Recargo (Servicio Propio)', 'valor': res.data.pjeRecargoServicioPropio, 'formato': 'porcentaje' },
                        
                        { 'nombre': 'pjeMargenMinimoCotizacion', 'campo': 'Pje Margen Mínimo (Global)', 'valor': res.data.pjeMargenMinimoCotizacion, 'formato': 'porcentaje' },
                        { 'nombre': 'pjeMargenMinimoCotizacionPropio', 'campo': 'Pje Margen Mínimo (Servicio Propio)', 'valor': res.data.pjeMargenMinimoCotizacionPropio, 'formato': 'porcentaje' },
                        { 'nombre': 'pjeMargenMinimoCotizacionTerceros', 'campo': 'Pje Margen Mínimo (Servicio Terceros)', 'valor': res.data.pjeMargenMinimoCotizacionTerceros, 'formato': 'porcentaje' },
                        
                        { 'nombre': 'servicioPropioNoAplicaFee', 'campo': 'Servicio Propio No Aplica Fee', 'valor': (res.data.servicioPropioNoAplicaFee) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'formaPago', 'campo': 'Forma de Pago', 'valor': res.data.formaPago, 'formato': '' },
                        { 'nombre': 'plazoPago', 'campo': 'Plazo de Pago', 'valor': res.data.plazoPago, 'formato': '' },
                        { 'nombre': 'numeroProveedor', 'campo': 'Nro. Proveedor', 'valor': res.data.numeroProveedor, 'formato': '' },
                        { 'nombre': 'grandesContribuyentes', 'campo': 'Grandes Contribuyentes (FCE MiPyME)', 'valor': (res.data.grandesContribuyentes) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'sistemaCirculacionAbierta', 'campo': 'Sist. Circulación Abierta (FCE MiPyME)', 'valor': (res.data.sistemaCirculacionAbierta) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'seleccionProvinciasPresupuestos', 'campo': 'Debe Seleccionar Provincias por Presupuesto', 'valor': (res.data.seleccionProvinciasPresupuestos) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    )

                    let clienteObservaciones = res.data.observaciones;

                    let params = {
                        clienteDatos,
                        clienteObservaciones,
                        clienteContactosAdministracionDatos: res.data.contactosAdministracion,
                        clienteRubrosTrabajosDatos: res.data.rubrosTrabajos,
                        clienteEscalasFeeDatos: res.data.escalasFee,
                        clienteEscalasFinanciacionDatos: res.data.escalasFinanciacion
                    };

                    commit('SET_DATOS', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}